import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ReapplyCTA = ({ application }) => {
  const navigate = useNavigate();
  const status = application?.status;

  if (status !== 'rejected') return null;

  return (
    <div
      className="rounded-2xl p-6"
      style={{
        background: 'linear-gradient(135deg, rgba(239,68,68,0.06) 0%, rgba(245,158,11,0.06) 100%)',
        border: '1px solid rgba(239,68,68,0.2)',
      }}
    >
      <div className="flex items-start gap-3 mb-5">
        <div
          className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)' }}
        >
          <Icon name="RefreshCw" size={16} color="#ef4444" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-white" style={{ fontFamily: 'DM Sans, sans-serif' }}>What's Next?</h3>
          <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.45)', lineHeight: '1.5' }}>
            You can start a new application after 30 days, or re-upload your documents if they were flagged during review.
          </p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={() => navigate('/card-application-form-screen')}
          className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl text-sm font-semibold transition-all hover:opacity-90 hover:scale-[1.01] active:scale-[0.99]"
          style={{ background: 'linear-gradient(135deg,#0d9488,#1d4ed8)', color: '#fff' }}
        >
          <Icon name="FilePlus" size={15} />
          Start New Application
        </button>
        <button
          onClick={() => navigate('/card-application-form-screen')}
          className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl text-sm font-semibold transition-all hover:opacity-90"
          style={{ background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.75)', border: '1px solid rgba(255,255,255,0.12)' }}
        >
          <Icon name="Upload" size={15} />
          Re-upload Documents
        </button>
      </div>
    </div>
  );
};

export default ReapplyCTA;
